import { observer } from 'mobx-react-lite';
import React from 'react';
import { colors } from '../../../../../../../../../colorVars';
import { useWebsocketStore } from '../../../../../../../../../stores/websocketStore/websocketProvider';
import { HoverBox } from '../../../hoverBox/HoverBox';
import { PendingTargetLine } from './PendingTargetLine';

export const UnderlyingPriceExitLine = observer(
  ({
    tradePlanId,
    underlyingPriceExits,
    pendingTargets,
    completeSoftOrder,
    size,
    scaleY,
    portalRef,
    fillPrice,
    openQuantity,
    priceMultiplier,
    realizedPnl,
    isLong,
    tickSize,
    delta,
  }) => {
    const { tradePlanStore } = useWebsocketStore();
    const tradePlan = tradePlanStore.tradePlans[tradePlanId] ?? null;
    const paused =
      tradePlan?.exitTactics['UNDERLYING_PRICE_EXIT']?.paused ?? null;
    const posMetrics = { fillPrice, openQuantity, priceMultiplier, realizedPnl, isLong, tickSize, delta };
    return (
      <>
        {scaleY ? (
          <g strokeWidth={1}>
            <g stroke={colors.green}>
              {underlyingPriceExits.map(({ price, qtyPct }, index) => {
                const yPos = scaleY(price);
                return (
                  <g key={price}>
                    {paused ? (
                      <line
                        strokeDasharray={4}
                        style={{ opacity: index === 0 ? 1 : 0.3 }}
                        x1={0}
                        x2={size}
                        y1={yPos}
                        y2={yPos}
                      />
                    ) : (
                      <line
                        style={{ opacity: index === 0 ? 1 : 0.3 }}
                        x1={0}
                        x2={size}
                        y1={yPos}
                        y2={yPos}
                      />
                    )}

                    <HoverBox
                      json={{
                        Category: 'Exit Tactic',
                        Type: 'Underlying Price',
                        'Pct. of Position': Number(qtyPct) * 100 + '%',
                      }}
                      topBoundary={yPos - 2}
                      bottomBoundary={yPos + 2}
                      leftBoundary={0}
                      rightBoundary={size}
                      portalRef={portalRef}
                      size={size}
                      linePrice={price}
                      {...posMetrics}
                    />
                  </g>
                );
              })}
            </g>
            {/* stock-mode pending reactive watches - a separate, independent block from the
                option-mode configured target list above: different semantics (watched/cancellable
                vs. always-shown configured list), populated by mutually-exclusive backend branches */}
            {(pendingTargets ?? []).map((target) => (
              <PendingTargetLine
                key={target.price}
                targetPrice={target.price}
                qty={target.qty}
                cancelKey={target.price}
                cancelKeyType="price"
                completeSoftOrder={completeSoftOrder}
                size={size}
                scaleY={scaleY}
                portalRef={portalRef}
              />
            ))}
          </g>
        ) : null}
      </>
    );
  }
);
